import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import {
  createCancelToken,
  handleErrorResponse,
  handleErrorResponseType,
  i18nMessages,
} from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * リクエストされたCSVファイルからタグ情報の一括再取り込み（登録・更新・削除）を行う。
 *
 * @param {string} apiToken - apiトークン
 * @param {File} uploadFile - タグ情報が記載されたcsvファイル
 * @param {string} selectedTagSetId - 選択中のタグセットID
 * @returns
 */
const reimportTags = (apiToken, uploadFile, selectedTagSetId) => dispatch => {
  consolelog('[API CALL] reimportTags()');
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_REIMPORT_TAGS.replace(
    '{tagSetId}',
    selectedTagSetId,
  );
  const { cancelToken, cancelTokenKey } = createCancelToken('reimportTags');
  const headers = { 'content-type': 'multipart/form-data' };
  const params = new FormData();
  params.append('uploadFile', uploadFile);
  params.append('cancelToken', cancelToken);
  const buttonName = i18nMessages['userPrompt.button.close'];
  const button = [{ name: buttonName, type: 1 }];
  return axios
    .post(url, params, { headers })
    .then(res => {
      delCancelToken(cancelTokenKey);
      dispatch({
        type: actionTypes.SUCCESS_API_REIMPORT_TAGS,
        payload: res.data,
      });
      if (res.data && res.data.result) {
        dispatch({
          type: actionTypes.OPEN_USER_PROMPT,
          promptMessage: i18nMessages['userPrompt.message.successImport'],
          buttonArray: button,
        });
      } else if (res.data.errorMessages) {
        dispatch({
          type: actionTypes.OPEN_IMPORT_ERROR_DIALOG,
          errorMessages: res.data.errorMessages,
        });
      } else {
        dispatch({
          type: actionTypes.OPEN_USER_PROMPT,
          promptMessage: i18nMessages['userPrompt.message.failureImport'],
          buttonArray: button,
        });
      }
    })
    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch, handleErrorResponseType.tags);
      }
    });
};

export default reimportTags;
